import { render, staticRenderFns } from "./CarSpecificationSelector.vue?vue&type=template&id=518e59b2"
import script from "./CarSpecificationSelector.vue?vue&type=script&lang=ts"
export * from "./CarSpecificationSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports